import mixpanel from 'mixpanel-browser';

/**
 * Wrapper seguro para mixpanel.track que só executa em produção
 * Evita tracking em ambientes de desenvolvimento e staging
 */
export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>,
): void => {
  if (process.env.REACT_APP_MIXPANEL_ENV === 'prod') {
    mixpanel.track(eventName, properties);
  }
  // Em dev/staging, não faz nada (silencioso)
};

/**
 * Wrapper seguro para mixpanel.identify que só executa em produção
 */
export const identifyUser = (userId: string): void => {
  if (process.env.REACT_APP_MIXPANEL_ENV === 'prod') {
    mixpanel.identify(userId);
  }
};

/**
 * Wrapper seguro para mixpanel.people.set que só executa em produção
 */
export const setUserProperties = (
  properties: Record<string, any>,
): void => {
  if (process.env.REACT_APP_MIXPANEL_ENV === 'prod') {
    mixpanel.people.set(properties);
  }
};

// Re-exportar mixpanel original para casos especiais
export { mixpanel };
